@if (currentLanguage === contentLanguage) {
  <ng-content></ng-content>
}
